export const getItem = (
  key: string,
  defaultValue?: string
): string | undefined => {
  const storageItem = localStorage.getItem(key);
  return storageItem !== null ? storageItem : defaultValue;
};

export const setItem = (key: string, value: string) =>
  localStorage.setItem(key, value);

export const removeItem = (key: string) => localStorage.removeItem(key);

export const clear = () => localStorage.clear();

export const getJsonItem = (key: string, defaultValue?: any): any => {
  const storageItem = localStorage.getItem(key);
  return storageItem !== null ? JSON.parse(storageItem) : defaultValue;
};

export const setJsonItem = (key: string, value: any) =>
  localStorage.setItem(key, JSON.stringify(value));
